export const FETCH_LIST_OCB_TRANSACTIONS = 'FETCH_LIST_OCB_TRANSACTIONS'
export const LOADING_LIST_OCB_TRANSACTIONS = 'LOADING_LIST_OCB_TRANSACTIONS'
export const SELECT_OCB_TRANSACTION = 'SELECT_OCB_TRANSACTION'

export const FETCH_LIST_OCB_REPAYMENT_TRANSACTIONS = 'FETCH_LIST_OCB_REPAYMENT_TRANSACTIONS'
export const LOADING_LIST_OCB_REPAYMENT_TRANSACTIONS = 'LOADING_LIST_OCB_REPAYMENT_TRANSACTIONS'
export const SELECT_OCB_REPAYMENT_TRANSACTION = 'SELECT_OCB_REPAYMENT_TRANSACTION'